<template>
    <v-dialog v-model="dialog" max-width="80vw" scrollable>
        <v-card style="margin: 0 auto;">
            <v-toolbar dark color="primary">
                <v-toolbar-title>{{ $t('ticket.print.title') }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>

            <v-card-text style="padding: 0;">
                <v-overlay :value="loading" z-index="9999">
                    <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
                </v-overlay>

                <!-- Content for PDF -->
                <div ref="pdfContent" v-if="ticket" style="padding: 30px 40px; background: white; font-size: 11px; margin: 0 auto; width: 80vw;">
                    <!-- Header -->
                    <div style="text-align: center; margin-bottom: 30px; border-bottom: 2px solid #1976d2; padding-bottom: 20px;">
                        <h1 style="color: #1976d2; margin-bottom: 10px; font-size: 18px;">{{ $t('ticket.print.header') }}</h1>
                        <h3 style="color: #666; font-size: 14px;">{{ ticket.titulo || '-' }}</h3>
                        <div style="color: #4a4a4a; font-size: 10px; margin-top: 10px;">
                            {{ $t('ticket.print.generatedOn') }}: {{ new Date().toLocaleString('pt-BR') }}
                        </div>
                    </div>

                    <!-- Ticket Information -->
                    <div style="margin-bottom: 25px;">
                        <h2 style="color: #1976d2; font-size: 14px; margin-bottom: 15px; border-bottom: 1px solid #e0e0e0; padding-bottom: 10px;">
                            {{ $t('ticket.information.title') }}
                        </h2>
                        <table style="width: 100%; border-collapse: collapse; font-size: 11px;">
                            <tr>
                                <td style="padding: 8px; width: 30%; font-weight: bold; color: #666; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ $t('ticket.headers.id') }}:</td>
                                <td style="padding: 8px; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ ticket.cod_ticket || ticket.id_ticket || '-' }}</td>
                            </tr>
                            <tr>
                                <td style="padding: 8px; font-weight: bold; color: #666; font-size: 11px;  word-wrap: break-word; overflow-wrap: break-word;">{{ $t('ticket.information.openingDate') }}:</td>
                                <td style="padding: 8px; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ ticket.dt_inclusao_extenso || '-' }}</td>
                            </tr>
                            <tr>
                                <td style="padding: 8px; font-weight: bold; color: #666; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ $t('ticket.information.requester') }}:</td>
                                <td style="padding: 8px; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ ticket.nome_usuario_inclusao || '-' }}</td>
                            </tr>
                            <tr v-if="solicitanteDisplayValue">
                                <td style="padding: 8px; font-weight: bold; color: #666; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ $t('ticket.createDialog.fields.claimant') }}:</td>
                                <td style="padding: 8px; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ solicitanteDisplayValue }}</td>
                            </tr>
                            <tr v-if="ticket.telefone_solicitante">
                                <td style="padding: 8px; font-weight: bold; color: #666; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ $t('ticket.createDialog.fields.telefoneSolicitante') }}:</td>
                                <td style="padding: 8px; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ ticket.telefone_solicitante }}</td>
                            </tr>
                            <tr>
                                <td style="padding: 8px; font-weight: bold; color: #666; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ $t('ticket.information.category') }}:</td>
                                <td style="padding: 8px; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ ticket.categoria_extenso || '-' }}</td>
                            </tr>
                            <tr>
                                <td style="padding: 8px; font-weight: bold; color: #666; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ $t('ticket.status.label') }}:</td>
                                <td style="padding: 8px; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ ticket.status_extenso || '-' }}</td>
                            </tr>
                            <tr>
                                <td style="padding: 8px; font-weight: bold; color: #666; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ $t('ticket.usuario.assigned') }}:</td>
                                <td style="padding: 8px; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ ticketAssigneesLine || $t('ticket.usuario.none') }}</td>
                            </tr>
                            <tr v-if="ticket.dt_agendamento_extenso">
                                <td style="padding: 8px; font-weight: bold; color: #666; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ $t('ticket.schedule.label') }}:</td>
                                <td style="padding: 8px; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ ticket.dt_agendamento_extenso }}</td>
                            </tr>
                            <tr v-if="ticket.endereco">
                                <td style="padding: 8px; font-weight: bold; color: #666; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ $t('ticket.createDialog.fields.localEmpresa') }}:</td>
                                <td style="padding: 8px; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ ticket.endereco }}</td>
                            </tr>
                            <tr>
                                <td style="padding: 8px; font-weight: bold; color: #666; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ $t('ticket.finalized.label') }}:</td>
                                <td style="padding: 8px; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ ticket.finalizado_extenso || 'Não' }}</td>
                            </tr>
                        </table>
                    </div>

                    <!-- Description -->
                    <div style="margin-bottom: 25px;" v-if="ticket.corpo">
                        <h2 style="color: #1976d2; font-size: 14px; margin-bottom: 15px; border-bottom: 1px solid #e0e0e0; padding-bottom: 10px; word-wrap: break-word; overflow-wrap: break-word;">
                            {{ $t('ticket.description.label') }}
                        </h2>
                        <div style="padding: 15px; background: #f5f5f5; border-radius: 5px; white-space: pre-wrap; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ ticket.corpo }}</div>
                    </div>

                    <!-- Equipamentos -->
                    <div style="margin-bottom: 25px;" v-if="equipamentos && equipamentos.length > 0">
                        <h2 style="color: #1976d2; font-size: 14px; margin-bottom: 15px; border-bottom: 1px solid #e0e0e0; padding-bottom: 10px; word-wrap: break-word; overflow-wrap: break-word;">
                            {{ $tc('equipment.self', 2) }}
                        </h2>
                        <table style="width: 100%; border-collapse: collapse; border: 1px solid #e0e0e0; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">
                            <thead>
                                <tr style="background: #f5f5f5;">
                                    <th style="padding: 10px; text-align: left; border: 1px solid #e0e0e0; font-size: 11px;">{{ $t('equipment.code') }}</th>
                                    <th style="padding: 10px; text-align: left; border: 1px solid #e0e0e0; font-size: 11px;">{{ $t('equipment.name') }}</th>
                                    <th style="padding: 10px; text-align: left; border: 1px solid #e0e0e0; font-size: 11px;">{{ $t('ticket.print.type') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(eq, index) in equipamentos" :key="index">
                                    <td style="padding: 8px; border: 1px solid #e0e0e0; font-size: 11px;">{{ eq.cod_equipamento || '-' }}</td>
                                    <td style="padding: 8px; border: 1px solid #e0e0e0; font-size: 11px;">{{ eq.nome_equipamento || '-' }}</td>
                                    <td style="padding: 8px; border: 1px solid #e0e0e0; font-size: 11px;">{{ eq.tipo === 'kit' ? $t('ticket.print.kit') : $t('ticket.print.equipment') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div style="margin-bottom: 25px;" v-if="equipamentosDoKit && equipamentosDoKit.length > 0">
                        <h2 style="color: #1976d2; font-size: 14px; margin-bottom: 15px; border-bottom: 1px solid #e0e0e0; padding-bottom: 10px; word-wrap: break-word; overflow-wrap: break-word;">
                            {{ $t('ticket.detail.kitLineItems') }}
                        </h2>
                        <table style="width: 100%; border-collapse: collapse; border: 1px solid #e0e0e0; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">
                            <thead>
                                <tr style="background: #f5f5f5;">
                                    <th style="padding: 10px; text-align: left; border: 1px solid #e0e0e0; font-size: 11px;">{{ $t('ticket.print.kit') }}</th>
                                    <th style="padding: 10px; text-align: left; border: 1px solid #e0e0e0; font-size: 11px;">{{ $t('equipment.code') }}</th>
                                    <th style="padding: 10px; text-align: left; border: 1px solid #e0e0e0; font-size: 11px;">{{ $t('equipment.name') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, idx) in equipamentosDoKit" :key="'k-' + (row.id_kit_equipamento != null ? row.id_kit_equipamento : idx)">
                                    <td style="padding: 8px; border: 1px solid #e0e0e0; font-size: 11px;">{{ row.kit_cod || row.id_kit || '-' }}</td>
                                    <td style="padding: 8px; border: 1px solid #e0e0e0; font-size: 11px;">{{ row.cod_equipamento || '-' }}</td>
                                    <td style="padding: 8px; border: 1px solid #e0e0e0; font-size: 11px;">{{ kitLineNamePrint(row) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Veículos -->
                    <div style="margin-bottom: 25px;" v-if="veiculos && veiculos.length > 0">
                        <h2 style="color: #1976d2; font-size: 14px; margin-bottom: 15px; border-bottom: 1px solid #e0e0e0; padding-bottom: 10px;">
                            {{ $tc('vehicle.self', 1) }}
                        </h2>
                        <table style="width: 100%; border-collapse: collapse; border: 1px solid #e0e0e0; font-size: 11px;">
                            <thead>
                                <tr style="background: #f5f5f5;">
                                    <th style="padding: 10px; text-align: left; border: 1px solid #e0e0e0; font-size: 11px;">{{ $t('vehicle.code') }}</th>
                                    <th style="padding: 10px; text-align: left; border: 1px solid #e0e0e0; font-size: 11px;">{{ $t('vehicle.plate') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(veic, index) in veiculos" :key="index">
                                    <td style="padding: 8px; border: 1px solid #e0e0e0; font-size: 11px;">{{ veic.cod_veiculo || '-' }}</td>
                                    <td style="padding: 8px; border: 1px solid #e0e0e0; font-size: 11px;">{{ veic.placa || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Equipes -->
                    <div style="margin-bottom: 25px;" v-if="equipes && equipes.length > 0">
                        <h2 style="color: #1976d2; font-size: 14px; margin-bottom: 15px; border-bottom: 1px solid #e0e0e0; padding-bottom: 10px;">
                            {{ $t('ticket.createDialog.fields.team') }}
                        </h2>
                        <div style="padding: 15px; background: #f5f5f5; border-radius: 5px; font-size: 11px;">
                            <span v-for="(eq, index) in equipes" :key="'equipe-' + index">
                                {{ eq.nome_equipe || '-' }}<span v-if="index < equipes.length - 1">, </span>
                            </span>
                        </div>
                    </div>

                    <!-- Tasks: last task only -->
                    <div style="margin-bottom: 25px;" v-if="lastTask">
                        <h2 style="color: #1976d2; font-size: 14px; margin-bottom: 15px; border-bottom: 1px solid #e0e0e0; padding-bottom: 10px;">
                            {{ $t('ticket.tasks.title') || 'Tarefas' }}
                        </h2>
                        <div style="font-size: 11px; border: 1px solid #e0e0e0; padding: 12px; background: #fafafa;">
                            <div style="margin-bottom: 6px;"><strong>{{ $t('ticket.tasks.taskId') || 'ID Tarefa' }}:</strong> {{ lastTask.taskId }}</div>
                            <div style="margin-bottom: 6px;"><strong>{{ $t('ticket.tasks.taskDescription') || 'Tarefa' }}:</strong> {{ lastTask.descricao_tarefa || '-' }}</div>
                            <div style="margin-bottom: 6px;"><strong>{{ $t('ticket.usuario.assigned') || 'Atribuído' }}:</strong> {{ ticketAssigneesLine || lastTask.nome_usuario_atribuido || '-' }}</div>
                            <div style="margin-bottom: 6px;"><strong>{{ $t('ticket.status.self') || 'Status' }}:</strong> {{ lastTask.task_status_extenso || '-' }}</div>
                            <div style="margin-bottom: 6px;"><strong>{{ $t('ticket.tasks.date') || 'Data' }}:</strong> {{ lastTask.dt_alteracao_extenso || '-' }}</div>
                            <div style="margin-bottom: 6px;"><strong>{{ $t('ticket.tasks.expectedCompletionDate') || 'Previsão conclusão' }}:</strong> {{ lastTask.dt_prevista_fim_extenso || '-' }}</div>
                            <div style="margin-bottom: 6px;"><strong>{{ $t('ticket.tasks.dateTimeInitial') || 'Dt/hora inicial' }}:</strong> {{ lastTask.dt_inicio_extenso || '-' }}</div>
                            <div style="margin-bottom: 6px;"><strong>{{ $t('ticket.tasks.dateTimeFinal') || 'Dt/hora final' }}:</strong> {{ lastTask.dt_fim_extenso || '-' }}</div>
                            <div style="margin-bottom: 6px;"><strong>{{ $t('ticket.tasks.externalObservation') || 'Obs. externa' }}:</strong> {{ lastTask.observacao_externa || '-' }}</div>
                            <div><strong>{{ $t('ticket.tasks.internalObservation') || 'Obs. interna' }}:</strong> {{ lastTask.observacao_interna || '-' }}</div>
                        </div>
                    </div>

                    <!-- Comments -->
                    <div style="margin-bottom: 25px;" v-if="comentarios && comentarios.length > 0">
                        <h2 style="color: #1976d2; font-size: 14px; margin-bottom: 15px; border-bottom: 1px solid #e0e0e0; padding-bottom: 10px; word-wrap: break-word; overflow-wrap: break-word;">
                            {{ $tc('ticket.comments.self', comentarios.length) }}
                        </h2>
                        <div v-for="(comentario, index) in comentarios" :key="index" style="margin-bottom: 15px; padding: 15px; background: #f5f5f5; border-radius: 5px; border-left: 4px solid #1976d2; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">
                            <div style="font-weight: bold; margin-bottom: 5px; color: #1976d2; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">
                                {{ comentario.nome_usuario_comentario || '-' }} - {{ comentario.dt_inclusao_extenso || comentario.dt_inclusao || '-' }}
                            </div>
                            <div style="white-space: pre-wrap; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ comentario.corpo || '-' }}</div>
                        </div>
                    </div>

                    <!-- Checklist -->
                    <div style="margin-bottom: 30px;" v-if="checklist && checklist.valores && checklist.valores.length > 0">
                        <h2 style="color: #1976d2; font-size: 14px; margin-bottom: 15px; border-bottom: 1px solid #e0e0e0; padding-bottom: 10px; word-wrap: break-word; overflow-wrap: break-word;">
                            {{ $t('equipmentChecklist.checklist') || 'Checklist' }}
                        </h2>
                        <div style="padding: 15px; background: #f5f5f5; border-radius: 5px; word-wrap: break-word; overflow-wrap: break-word;">
                            <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px; font-size: 11px;" v-if="checklist.dt_inclusao_extenso || checklist.dt_alteracao_extenso || checklist.dt_realizacao_extenso || checklist.observacoes">
                                <tr v-if="checklist.dt_inclusao_extenso">
                                    <td style="padding: 8px; width: 30%; font-weight: bold; color: #666; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ $t('equipmentChecklist.headers.createdAt') || 'Data de Criação' }}:</td>
                                    <td style="padding: 8px; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ checklist.dt_inclusao_extenso }}</td>
                                </tr>
                                <tr v-if="checklist.dt_alteracao_extenso || checklist.dt_realizacao_extenso">
                                    <td style="padding: 8px; font-weight: bold; color: #666; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ $t('equipmentChecklist.realizationDateTime') || 'Data de Realização' }}:</td>
                                    <td style="padding: 8px; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ checklist.dt_alteracao_extenso || checklist.dt_realizacao_extenso }}</td>
                                </tr>
                                <tr v-if="checklist.observacoes">
                                    <td style="padding: 8px; font-weight: bold; color: #666; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ $t('equipmentChecklist.observations') || 'Observações' }}:</td>
                                    <td style="padding: 8px; white-space: pre-wrap; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ checklist.observacoes }}</td>
                                </tr>
                            </table>
                            <table style="width: 100%; border-collapse: collapse; border: 1px solid #e0e0e0; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">
                                <thead>
                                    <tr style="background: #f5f5f5;">
                                        <th style="padding: 10px; text-align: left; border: 1px solid #e0e0e0; font-size: 11px;">{{ $t('equipmentChecklist.fieldLabel') || 'Campo' }}</th>
                                        <th style="padding: 10px; text-align: left; border: 1px solid #e0e0e0; font-size: 11px;">{{ $t('ticket.print.value') || 'Valor' }}</th>
                                        <th style="padding: 10px; text-align: left; border: 1px solid #e0e0e0; font-size: 11px;">{{ $t('ticket.print.editedBy') || 'Editado por' }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(valor, index) in checklist.valores" :key="index" :style="valor.tipo && valor.tipo.toLowerCase() === 'photo' && valor.valor ? 'page-break-inside: avoid; break-inside: avoid;' : ''">
                                        <td style="padding: 8px; border: 1px solid #e0e0e0; font-weight: bold; color: #1976d2; width: 30%; font-size: 11px; word-wrap: break-word; overflow-wrap: break-word;">{{ valor.label || 'Campo' }}</td>
                                        <td style="padding: 8px; border: 1px solid #e0e0e0; word-wrap: break-word; overflow-wrap: break-word;">
                                            <div v-if="valor.tipo && valor.tipo.toLowerCase() === 'checkbox'" style="color: #333; font-size: 11px;">
                                                {{ formatCheckboxValue(valor.valor) }}
                                            </div>
                                            <div v-else-if="valor.tipo && valor.tipo.toLowerCase() === 'photo' && valor.valor" style="margin-top: 5px; page-break-inside: avoid; break-inside: avoid; display: inline-block; width: 100%;">
                                                <img 
                                                    :src="getImageUrl(valor.valor)" 
                                                    style="max-width: 100%; max-height: 350px; height: auto; border: 1px solid #e0e0e0; border-radius: 3px; word-wrap: break-word; overflow-wrap: break-word; page-break-inside: avoid; break-inside: avoid; display: block; object-fit: contain;" 
                                                    alt="Checklist Photo"
                                                    crossOrigin="anonymous"
                                                    @load="onImageLoad"
                                                />
                                            </div>
                                            <div v-else style="color: #333; white-space: pre-wrap; font-size: 11px;">{{ formatFieldValue(valor.valor) }}</div>
                                        </td>
                                        <td style="padding: 8px; border: 1px solid #e0e0e0; font-size: 10px; color: #666; word-wrap: break-word; overflow-wrap: break-word;">
                                            <template v-if="valor.nome_usuario_alteracao || valor.dt_alteracao_extenso">
                                                {{ valor.nome_usuario_alteracao || '-' }}<template v-if="valor.dt_alteracao_extenso"> — {{ valor.dt_alteracao_extenso }}</template>
                                            </template>
                                            <template v-else>—</template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- Additional photos -->
                            <div v-if="checklist.fotos_extra && checklist.fotos_extra.length" style="margin-top: 15px; page-break-inside: avoid;">
                                <div style="font-weight: bold; color: #666; font-size: 11px; margin-bottom: 8px;">{{ $t('equipmentChecklist.additionalPhotos') || 'Fotos adicionais' }}:</div>
                                <div style="display: flex; flex-wrap: wrap; gap: 10px;">
                                    <template v-for="(path, idx) in checklist.fotos_extra">
                                        <img
                                            v-if="getChecklistMediaTypeFromPath(path) === 'image'"
                                            :key="'extra-' + idx"
                                            :src="getImageUrl(path)"
                                            style="max-width: 120px; max-height: 120px; height: auto; border: 1px solid #e0e0e0; border-radius: 3px; object-fit: contain; page-break-inside: avoid;"
                                            alt="Additional photo"
                                            crossOrigin="anonymous"
                                            @load="onImageLoad"
                                        />
                                        <span v-else :key="'extra-' + idx" style="display: inline-block; padding: 8px 12px; border: 1px solid #e0e0e0; border-radius: 3px; font-size: 10px; color: #666;">{{ getChecklistMediaTypeFromPath(path) === 'video' ? ($t('equipmentChecklist.video') || 'Vídeo') : ($t('equipmentChecklist.zipFile') || 'ZIP') }}</span>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- History -->
                    <div style="margin-bottom: 25px;" v-if="historico && historico.length > 0">
                        <div style="page-break-inside: avoid !important; break-inside: avoid !important;">
                            <h2 style="color: #1976d2; font-size: 14px; margin-bottom: 15px; border-bottom: 1px solid #e0e0e0; padding-bottom: 12px; page-break-inside: avoid !important; break-inside: avoid !important; word-wrap: break-word; overflow-wrap: break-word;">
                                {{ $t('ticket.history.title') }}
                            </h2>
                        </div>
                        <table style="width: 100%; border-collapse: collapse; border: 1px solid #e0e0e0; font-size: 11px; page-break-inside: auto; table-layout: fixed;">
                            <thead>
                                <tr style="background: #f5f5f5; page-break-inside: avoid; break-inside: avoid;">
                                    <th style="padding: 8px; text-align: left; border: 1px solid #e0e0e0; font-size: 12px;">{{ $t('ticket.history.date') }}</th>
                                    <th style="padding: 8px; text-align: left; border: 1px solid #e0e0e0; font-size: 12px;">{{ $t('ticket.history.user') }}</th>
                                    <th style="padding: 8px; text-align: left; border: 1px solid #e0e0e0; font-size: 12px;">{{ $t('ticket.history.field') }}</th>
                                    <th style="padding: 8px; text-align: left; border: 1px solid #e0e0e0; font-size: 12px;">{{ $t('ticket.history.oldValue') }}</th>
                                    <th style="padding: 8px; text-align: left; border: 1px solid #e0e0e0; font-size: 12px;">{{ $t('ticket.history.newValue') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(hist, index) in historico" :key="index" style="page-break-inside: avoid !important; break-inside: avoid !important; page-break-after: avoid !important; orphans: 3; widows: 3; display: table-row; height: auto; box-sizing: border-box;">
                                    <td style="padding: 6px 8px; border: 1px solid #e0e0e0; font-size: 12px; vertical-align: top; line-height: 1.3;">
                                        <div style="page-break-inside: avoid !important; break-inside: avoid !important; word-wrap: break-word; overflow-wrap: break-word; hyphens: none;">{{ hist.dt_alteracao_extenso || hist.dt_alteracao || '-' }}</div>
                                    </td>
                                    <td style="padding: 6px 8px; border: 1px solid #e0e0e0; font-size: 12px; vertical-align: top; line-height: 1.3;">
                                        <div style="page-break-inside: avoid !important; break-inside: avoid !important; word-wrap: break-word; overflow-wrap: break-word; hyphens: none;">{{ hist.nome_usuario || '-' }}</div>
                                    </td>
                                    <td style="padding: 6px 8px; border: 1px solid #e0e0e0; font-size: 12px; vertical-align: top; line-height: 1.3;">
                                        <div style="page-break-inside: avoid !important; break-inside: avoid !important; word-wrap: break-word; overflow-wrap: break-word; hyphens: none;">{{ formatFieldName(hist.campo_alterado) }}</div>
                                    </td>
                                    <td style="padding: 6px 8px; border: 1px solid #e0e0e0; font-size: 12px; vertical-align: top; line-height: 1.3;">
                                        <div style="page-break-inside: avoid !important; break-inside: avoid !important; word-wrap: break-word; overflow-wrap: break-word; hyphens: none;">{{ formatHistoryValue(hist.campo_alterado, hist.valor_anterior) || '-' }}</div>
                                    </td>
                                    <td style="padding: 6px 8px; border: 1px solid #e0e0e0; font-size: 12px; vertical-align: top; line-height: 1.3;">
                                        <div style="page-break-inside: avoid !important; break-inside: avoid !important; word-wrap: break-word; overflow-wrap: break-word; hyphens: none;">{{ formatHistoryValue(hist.campo_alterado, hist.valor_novo) || '-' }}</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey" text @click="close">{{ $t('button.cancel') }}</v-btn>
                <v-btn color="primary" @click="generatePDF" :loading="loadingPdf" :disabled="loading || loadingPdf">
                    <v-icon left>mdi-file-pdf-box</v-icon>
                    {{ $t('system.labels.exportToPdf') }}
                </v-btn>
            </v-card-actions>
        </v-card>

        <!-- Vue HTML2PDF Component -->
        <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="false"
            :paginate-elements-by-height="verticalSize"
            :key="verticalSize"
            :filename="pdfFilename"
            :pdf-quality="2"
            :manual-pagination="true"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="100%"
            :html-to-pdf-options="htmlToPdfOptions"
            @progress="onPdfProgress"
            @hasStartedGeneration="onPdfStart"
            @hasGenerated="onPdfComplete"
            ref="html2Pdf"
            class="html2pdf__page-break"
        >
            <section slot="pdf-content" v-if="ticket && pdfContentHtml" style="margin: 0 !important; padding: 0 !important; width: 100%; box-sizing: border-box; display: block;">
                <div ref="pdfContentSlot" v-html="pdfContentHtml" style="margin: 0 !important; padding-top: 0 !important; width: 100%; box-sizing: border-box;"></div>
            </section>
        </vue-html2pdf>
    </v-dialog>
</template>

<script>
import apiController from '@/utils/apiController';
import { ApiBaseUrl } from '@/constants';
import VueHtml2pdf from 'vue-html2pdf';
import { ticketAssigneesDisplayLabel } from '@/utils/ticketAssignees';
import { normalizeGetTicketEquipamentosResponse } from '@/utils/ticketEquipamentosResponse';

export default {
    name: 'TicketPrintView',
    components: {
        VueHtml2pdf
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        ticketId: {
            type: [Number, String],
            default: null
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            loadingPdf: false,
            ticket: null,
            equipamentos: [],
            equipamentosDoKit: [],
            veiculos: [],
            equipes: [],
            comentarios: [],
            checklist: null,
            historico: [],
            usuarios: [],
            usuariosMap: {},
            statusList: [],
            statusMap: {},
            token: null,
            pdfContentHtml: '',
            ticketTasks: []
        };
    },
    computed: {
        ticketAssigneesLine() {
            return ticketAssigneesDisplayLabel(this.ticket);
        },
        solicitanteDisplayValue() {
            const t = this.ticket;
            if (!t) return '';
            const isAgencia = String(t.tipo_ticket_extenso || '').trim() === 'SOLICITAÇÃO DE CANDIDATOS (AGÊNCIA)';
            if (isAgencia) {
                const emailRec = t.email_recuperacao_usuario_inclusao != null
                    ? String(t.email_recuperacao_usuario_inclusao).trim()
                    : '';
                if (emailRec) return emailRec;
                const login = t.login_usuario_inclusao != null
                    ? String(t.login_usuario_inclusao).trim()
                    : '';
                if (login) return login;
                const stored = t.solicitacao_candidatos_solicitante_email != null
                    ? String(t.solicitacao_candidatos_solicitante_email).trim()
                    : '';
                if (stored && stored.includes('@')) return stored;
            }
            const nome = t.nome_usuario_solicitante;
            return nome != null ? String(nome).trim() : '';
        },
        lastTask() {
            if (!this.ticketTasks || this.ticketTasks.length === 0) return null;
            return this.ticketTasks[this.ticketTasks.length - 1];
        },
        htmlToPdfOptions() {
            const id = (this.ticket && this.ticket.id_ticket) ? this.ticket.id_ticket : 'unknown';
            const dateStr = new Date().toISOString().split('T')[0];
            return {
                margin: [10, 10, 10, 10],
                filename: `ticket_${id}_${dateStr}.pdf`,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { 
                    scale: 2,
                    useCORS: true,
                    logging: false,
                    letterRendering: true,
                    allowTaint: true,
                    timeout: 30000,
                    scrollX: 0,
                    scrollY: 0,
                    windowWidth: 794,
                    windowHeight: 1123
                },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
                onclone: (clonedDoc) => {
                    // Enhance table rows in cloned document to prevent breaks
                    const tableRows = clonedDoc.querySelectorAll('tbody tr');
                    tableRows.forEach(row => {
                        row.style.pageBreakInside = 'avoid';
                        row.style.breakInside = 'avoid';
                        row.style.display = 'table-row';
                        // Ensure row is treated as a single unit
                        const cells = row.querySelectorAll('td');
                        cells.forEach(cell => {
                            cell.style.pageBreakInside = 'avoid';
                            cell.style.breakInside = 'avoid';
                            cell.style.verticalAlign = 'top';
                            
                            // Wrap cell content in a div if it's not already wrapped
                            // This prevents words from being cut across pages
                            if (cell.children.length === 0 || cell.children[0].tagName !== 'DIV') {
                                const textContent = cell.innerHTML;
                                const wrapper = clonedDoc.createElement('div');
                                wrapper.style.pageBreakInside = 'avoid';
                                wrapper.style.breakInside = 'avoid';
                                wrapper.style.wordWrap = 'break-word';
                                wrapper.style.overflowWrap = 'break-word';
                                wrapper.style.hyphens = 'none';
                                wrapper.innerHTML = textContent;
                                cell.innerHTML = '';
                                cell.appendChild(wrapper);
                            } else {
                                // If already wrapped, ensure the div has the right styles
                                const div = cell.querySelector('div');
                                if (div) {
                                    div.style.pageBreakInside = 'avoid';
                                    div.style.breakInside = 'avoid';
                                    div.style.wordWrap = 'break-word';
                                    div.style.overflowWrap = 'break-word';
                                    div.style.hyphens = 'none';
                                }
                            }
                        });
                    });
                }
            };
        },
        pdfFilename() {
            if (this.ticket && this.ticket.id_ticket) {
                return `ticket_${this.ticket.id_ticket}_${new Date().toISOString().split('T')[0]}`;
            }
            return 'ticket';
        },
        verticalSize() {
            return Math.ceil(document.documentElement.scrollHeight / window.innerHeight);
        }
    },
    watch: {
        value(newVal) {
            this.dialog = newVal;
            if (newVal && this.ticketId) {
                this.loadTicketData();
            }
        },
        dialog(newVal) {
            this.$emit('input', newVal);
        }
    },
    mounted() {
        this.token = sessionStorage.getItem('api');
    },
    methods: {
        kitLineNamePrint(row) {
            const base = row.nome_equipamento || row.codigo_qrcode || row.nome_tipo_equipamento || '-';
            if (row.quantidade != null && row.quantidade > 1) {
                return `${base} ×${row.quantidade}`;
            }
            return base;
        },
        close() {
            this.dialog = false;
            this.$emit('input', false);
        },
        /** Resolve so os usuarios citados no historico, em vez de baixar a base inteira. */
        async fetchUsuariosDoHistorico(historico) {
            const ids = new Set();
            (Array.isArray(historico) ? historico : []).forEach((hist) => {
                if (!hist || hist.campo_alterado !== 'id_usuario_atribuido') return;
                [hist.valor_anterior, hist.valor_novo].forEach((valor) => {
                    if (valor == null || valor === '') return;
                    const id = parseInt(String(valor).trim(), 10);
                    if (Number.isFinite(id) && id > 0) ids.add(id);
                });
            });
            if (ids.size === 0) return [];
            const res = await apiController.request(apiController.endpoints.getUsuariosporids, {
                data: { id_usuarios: [...ids] },
                silent: true,
            }).catch(() => ({ data: [] }));
            return Array.isArray(res.data) ? res.data : [];
        },
        async loadTicketData() {
            if (!this.ticketId) return;
            
            this.loading = true;
            try {
                const fullRes = await apiController.request(apiController.endpoints.getTicketbyid, {
                    params: { id: this.ticketId },
                    silent: true,
                });
                const ticket = fullRes.data && !fullRes.data.erro ? fullRes.data : null;

                if (!ticket) {
                    throw new Error('Ticket not found');
                }

                const [equipamentosRes, veiculosRes, equipesRes, allEquipesRes, statusRes, comentariosRes, checklistRes, historicoRes, tasksRes] = await Promise.all([
                    apiController.request(apiController.endpoints.getTicketequipamentos, {
                        params: { id: this.ticketId }, silent: true
                    }),
                    apiController.request(apiController.endpoints.getTicketveiculos, {
                        params: { id: this.ticketId }, silent: true
                    }),
                    apiController.request(apiController.endpoints.getTicketequipes, {
                        params: { id: this.ticketId }, silent: true
                    }),
                    apiController.request(apiController.endpoints.getallEquipes, { silent: true }),
                    apiController.request(apiController.endpoints.getallStatus, { silent: true }),
                    apiController.request(apiController.endpoints.getComentariosbyticketid, {
                        params: { id: this.ticketId }, silent: true
                    }),
                    apiController.request(apiController.endpoints.getChecklistequipamentorespostaporticket, {
                        params: { id_ticket: this.ticketId }, silent: true
                    }).catch(() => ({ data: { erro: true, dados: null } })),
                    // Histórico é só de superadmin e administradores: para os demais, o PDF sai sem a seção.
                    apiController.request(apiController.endpoints.getTickethistory, {
                        params: { id_ticket: this.ticketId }, silent: true
                    }).catch(() => ({ data: { erro: true, dados: [] } })),
                    apiController.request(apiController.endpoints.getTickettasks, {
                        params: { id_ticket: this.ticketId }, silent: true
                    }).catch(() => ({ data: { erro: true, dados: [] } }))
                ]);

                this.ticket = ticket;
                const eqNorm = normalizeGetTicketEquipamentosResponse(equipamentosRes.data);
                this.equipamentos = eqNorm.equipamentos;
                this.equipamentosDoKit = eqNorm.equipamentos_do_kit;
                this.veiculos = Array.isArray(veiculosRes.data) ? veiculosRes.data : [];
                
                // Map team IDs to full team objects with names
                const teamIds = Array.isArray(equipesRes.data) ? equipesRes.data : [];
                const allTeams = Array.isArray(allEquipesRes.data) ? allEquipesRes.data : [];
                this.equipes = teamIds.map(id => {
                    const team = allTeams.find(t => t.id_equipe == id);
                    return team ? { id_equipe: team.id_equipe, nome_equipe: team.nome_equipe } : { id_equipe: id, nome_equipe: `Equipe ${id}` };
                });
                
                // Create status map for history formatting
                this.statusList = Array.isArray(statusRes.data) ? statusRes.data : [];
                this.statusMap = {};
                this.statusList.forEach(status => {
                    if (status.id_status_ticket && status.status_ticket) {
                        this.statusMap[status.id_status_ticket] = status.status_ticket;
                        this.statusMap[String(status.id_status_ticket)] = status.status_ticket;
                    }
                });
                
                this.comentarios = Array.isArray(comentariosRes.data) ? comentariosRes.data : [];
                
                // Handle checklist response format
                if (checklistRes.data && checklistRes.data.erro === false && checklistRes.data.dados) {
                    this.checklist = checklistRes.data.dados;
                } else {
                    this.checklist = null;
                }
                
                // Handle history response format
                if (historicoRes.data && historicoRes.data.erro === false && historicoRes.data.dados) {
                    this.historico = Array.isArray(historicoRes.data.dados) ? historicoRes.data.dados : [];
                } else if (Array.isArray(historicoRes.data)) {
                    this.historico = historicoRes.data;
                } else {
                    this.historico = [];
                }

                // Users map for history formatting (only the ids the history mentions)
                this.usuarios = await this.fetchUsuariosDoHistorico(this.historico);
                this.usuariosMap = {};
                this.usuarios.forEach(user => {
                    this.usuariosMap[user.id_usuario] = user.nome_usuario;
                    this.usuariosMap[String(user.id_usuario)] = user.nome_usuario;
                });

                // Handle tasks response (ticketId.1, .2, ... by attribution change count)
                if (tasksRes.data && tasksRes.data.erro === false && Array.isArray(tasksRes.data.dados)) {
                    this.ticketTasks = tasksRes.data.dados;
                } else {
                    this.ticketTasks = [];
                }

                // Prepare HTML content for PDF
                this.$nextTick(() => {
                    if (this.$refs.pdfContent) {
                        this.pdfContentHtml = this.$refs.pdfContent.innerHTML;
                    }
                });
            } catch (error) {
                console.error('Error loading ticket data:', error);
                this.$root.$emit('show-error', { error });
            } finally {
                this.loading = false;
            }
        },
        async generatePDF() {
            if (!this.$refs.pdfContent) {
                console.error('PDF content ref not found');
                this.$root.$emit('show-error', { error: new Error('Conteúdo não disponível para geração do PDF') });
                return;
            }
            
            // Preload all images before generating PDF
            await this.preloadImages();

            
            // Wait for DOM update to ensure v-html is rendered
            await this.$nextTick();
            
            // Small delay to ensure content is fully rendered in the slot
            setTimeout(() => {
                if (this.$refs.html2Pdf) {
                    this.$refs.html2Pdf.generatePdf();
                } else {
                    console.error('html2Pdf ref not found');
                    this.$root.$emit('show-error', { error: new Error('Componente de PDF não encontrado') });
                }
            }, 200);
        },
        processWrapperStyle(style) {
            // Process the wrapper div's style to remove top padding
            let currentStyle = style || '';
            
            // Remove top padding: change "padding: 30px 40px" to "padding: 0 40px 30px 40px"
            // This handles common padding formats
            currentStyle = currentStyle.replace(
                /padding\s*:\s*(\d+px)\s+(\d+px)/gi, 
                (match, first, second) => `padding: 0 ${second} ${first} ${second}`
            );
            
            // Handle padding with 4 values: "padding: 30px 40px 30px 40px"
            currentStyle = currentStyle.replace(
                /padding\s*:\s*(\d+px)\s+(\d+px)\s+(\d+px)\s+(\d+px)/gi,
                (match, top, right, bottom, left) => `padding: 0 ${right} ${bottom} ${left}`
            );
            
            // Handle single value padding: "padding: 30px" -> "padding: 0 30px 30px 30px"
            currentStyle = currentStyle.replace(
                /padding\s*:\s*(\d+px)/gi,
                (match, value) => `padding: 0 ${value} ${value} ${value}`
            );
            
            // Remove any explicit padding-top
            currentStyle = currentStyle.replace(/padding-top\s*:\s*[^;]+;?/gi, '');
            
            // Remove any margin-top
            currentStyle = currentStyle.replace(/margin-top\s*:\s*[^;]+;?/gi, '');
            
            // Fix margin conflicts - remove conflicting margin declarations
            // First, check if margin: 0 auto exists
            const hasMarginAuto = /margin\s*:\s*0\s+auto/gi.test(currentStyle);
            
            // Remove all margin declarations
            currentStyle = currentStyle.replace(/margin\s*:\s*[^;]+;?/gi, '');
            
            // Re-add margin: 0 auto if it was there, otherwise use margin: 0
            if (hasMarginAuto) {
                currentStyle += (currentStyle ? '; ' : '') + 'margin: 0 auto';
            } else {
                currentStyle += (currentStyle ? '; ' : '') + 'margin: 0';
            }
            
            // Clean up multiple semicolons and spaces
            currentStyle = currentStyle.replace(/;\s*;/g, ';').replace(/^\s*;\s*/, '').trim();
            
            return currentStyle;
        },
        processHtmlForPdf(html) {
            // Create a temporary container to parse and modify the HTML
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            
            // Fix conflicting margin declarations in all divs
            // The issue is when margin-bottom is set but then margin: 0 overrides it
            const allDivs = tempDiv.querySelectorAll('div');
            allDivs.forEach(div => {
                let divStyle = div.getAttribute('style') || '';
                
                // Remove margin-top from all divs to prevent blank space at top
                divStyle = divStyle.replace(/margin-top\s*:\s*[^;]+;?/gi, '');
                
                // Check for conflicting margin declarations
                // If there's both margin-bottom and margin: 0, the margin: 0 overrides margin-bottom
                // We need to preserve margin-bottom and remove the conflicting margin: 0
                const hasMarginBottom = /margin-bottom\s*:\s*[^;]+/gi.test(divStyle);
                const hasMarginZero = /margin\s*:\s*0(\s+auto)?/gi.test(divStyle);
                
                if (hasMarginBottom && hasMarginZero) {
                    // Extract margin-bottom value
                    const marginBottomMatch = divStyle.match(/margin-bottom\s*:\s*[^;]+/gi);
                    // Remove all margin declarations
                    divStyle = divStyle.replace(/margin\s*:\s*[^;]+;?/gi, '');
                    // Re-add margin-bottom if it existed
                    if (marginBottomMatch) {
                        divStyle += (divStyle ? '; ' : '') + marginBottomMatch[0];
                    }
                }
                
                // Clean up multiple semicolons and spaces
                divStyle = divStyle.replace(/;\s*;/g, ';').replace(/^\s*;\s*/, '').trim();
                if (divStyle) {
                    div.setAttribute('style', divStyle);
                }
            });
            
            // Enhance table rows to prevent page breaks
            const tableRows = tempDiv.querySelectorAll('tbody tr');
            tableRows.forEach(row => {
                let rowStyle = row.getAttribute('style') || '';
                // Add or enhance page-break prevention
                row.setAttribute('style', rowStyle);
                
                // Also ensure all cells have page-break prevention
                const cells = row.querySelectorAll('td');
                cells.forEach(cell => {
                    let cellStyle = cell.getAttribute('style') || '';
                    cell.setAttribute('style', cellStyle);
                });
            });
            
            return tempDiv.innerHTML;
        },
        onImageLoad() {
            // Image loaded callback - can be used for tracking
        },
        preloadImages() {
            return new Promise((resolve) => {
                if (!this.$refs.pdfContent) {
                    resolve();
                    return;
                }
                
                const images = this.$refs.pdfContent.querySelectorAll('img');
                if (images.length === 0) {
                    resolve();
                    return;
                }
                
                let loaded = 0;
                const total = images.length;
                
                const checkComplete = () => {
                    loaded++;
                    if (loaded === total) {
                        // Wait a bit more to ensure images are fully rendered
                        setTimeout(resolve, 1000);
                    }
                };
                
                images.forEach((img) => {
                    // Set crossOrigin if not already set
                    if (!img.crossOrigin) {
                        img.crossOrigin = 'anonymous';
                    }
                    
                    if (img.complete && img.naturalHeight !== 0) {
                        checkComplete();
                    } else {
                        img.onload = checkComplete;
                        img.onerror = checkComplete; // Continue even if image fails to load
                    }
                });
                
                // Timeout fallback
                setTimeout(resolve, 15000);
            });
        },
        onPdfStart() {
            this.loadingPdf = true;
        },
        onPdfProgress() {
            // Progress tracking if needed
        },
        onPdfComplete() {
            this.loadingPdf = false;
        },
        formatFieldName(field) {
            if (!field) return field;
            
            const normalizedField = String(field).trim();
            
            // Fallback labels (most reliable)
            const fallbackLabels = {
                'id_status': 'Status',
                'id_usuario_atribuido': 'Usuário Atribuído',
                'dt_agendamento': 'Data de Agendamento',
                'finalizado': 'Finalizado',
                'id_equipes': 'Equipes',
                'checklist_preenchido': 'Checklist Preenchido',
                'checklist_atualizado': 'Checklist Atualizado',
                'sla_manual': 'Previsão de Resolução manual'
            };
            
            // Check fallback first
            if (normalizedField in fallbackLabels) {
                return fallbackLabels[normalizedField];
            }
            
            // Try translations
            const fieldNames = {
                'id_status': this.$t('ticket.status.label'),
                'id_usuario_atribuido': this.$t('ticket.usuario.assigned'),
                'dt_agendamento': this.$t('ticket.schedule.label'),
                'finalizado': this.$t('ticket.finalized.label'),
                'id_equipes': this.$t('ticketHistory.fields.id_equipes') || 'Equipes',
                'checklist_preenchido': this.$t('ticket.history.checklistFilled') || 'Checklist Preenchido',
                'checklist_atualizado': this.$t('ticket.history.checklistUpdated') || 'Checklist Atualizado'
            };
            
            const translated = fieldNames[normalizedField];
            if (translated && translated !== `ticketHistory.fields.${normalizedField}`) {
                return translated;
            }
            
            return normalizedField;
        },
        formatHistoryValue(field, value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }
            
            // Format based on field type
            if (field === 'id_status') {
                // Look up status name from statusMap
                const statusId = String(value).trim();
                const statusName = this.statusMap[statusId] || this.statusMap[parseInt(statusId)];
                return statusName || value;
            } else if (field === 'id_usuario_atribuido') {
                // Look up user name from usuariosMap
                const userId = String(value).trim();
                const userName = this.usuariosMap[userId] || this.usuariosMap[parseInt(userId)];
                return userName || value;
            } else if (field === 'finalizado') {
                return value === '1' || value === 1 ? (this.$t('system.yes') || 'Sim') : (this.$t('system.no') || 'Não');
            }
            
            return String(value);
        },
        getChecklistMediaTypeFromPath(path) {
            if (!path || typeof path !== 'string') return 'image';
            const p = path.toLowerCase();
            if (/\.(mp4|mov|avi|webm)$/.test(p)) return 'video';
            if (/\.zip$/.test(p)) return 'zip';
            return 'image';
        },
        getImageUrl(path) {
            if (!path) {
                return '';
            }
            // If path already starts with http or https, use it as is
            if (path.startsWith('http://') || path.startsWith('https://')) {
                return path;
            }
            // The API returns: "static/uploads/checklists_equipamentos/filename.jpg"
            // express.static serves from /static root, so we need to remove "static/" prefix
            // Result: "/uploads/checklists_equipamentos/filename.jpg"
            let cleanPath = path;
            if (cleanPath.startsWith('static/uploads/')) {
                cleanPath = cleanPath.substring(7); // Remove "static/" -> "uploads/..."
            } else if (cleanPath.startsWith('static/')) {
                cleanPath = cleanPath.substring(7); // Remove "static/" -> "..."
            }
            // Ensure leading slash
            if (!cleanPath.startsWith('/')) {
                cleanPath = '/' + cleanPath;
            }
            return `${ApiBaseUrl}${cleanPath}`;
        },
        formatCheckboxValue(value) {
            if (value === null || value === undefined || value === '') {
                return '-';
            }
            // Handle various checkbox value formats: true, 'true', 1, '1', false, 'false', 0, '0'
            const normalizedValue = String(value).toLowerCase().trim();
            if (normalizedValue === 'true' || normalizedValue === '1' || value === true || value === 1) {
                return this.$t('system.yes') || 'Sim';
            } else if (normalizedValue === 'false' || normalizedValue === '0' || value === false || value === 0) {
                return this.$t('system.no') || 'Não';
            }
            return '-';
        },
        formatFieldValue(value) {
            if (value === null || value === undefined || value === '') {
                return '-';
            }
            return String(value);
        }
    }
};
</script>

<style scoped>
    .html2pdf__page-break {
        margin: 0 !important;
    }
</style>
